import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AddModal from './components/common/AddModal';
import Sidebar from './components/common/Sidebar';
import AuthIndex from "./screens/AuthIndex";
import MainIndex from './screens/MainIndex';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import socket from './socket/socket';
import { AuthProvider } from './context/AuthContext';
import { PrivilegesConfigProvider } from './context/PrivilegesConfigContext';

function App(props) {
  const location = useLocation();
  const activekey = () => location.pathname;

  const [isConnected, setIsConnected] = useState(socket.connected);

  const authRoutes = [
    '/sign-in', '/sign-up', '/reset-password',
    '/verification/:id', '/login-otp-verification', '/page-404'
  ];

  useEffect(() => {
    const senderData = JSON.parse(localStorage.getItem("vedhvidhi-admin-data"));
    const senderId = senderData?._id;

    const onConnect = () => {
      setIsConnected(true);
      if (senderId) {
        socket.emit("new user", senderId);
      }
    };

    const onDisconnect = () => {
      setIsConnected(false);
    };

    const handleNewTicket = (data) => {
      const ticketId = data?.ticketId || 'a new';
      toast.info(`New Support Ticket Received`);
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('new ticket', handleNewTicket);
    if (socket.connected) {
      onConnect();
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('new ticket', handleNewTicket);
    };
  }, [location]);

  const toastContainer = (
    <ToastContainer />
  );

  if (authRoutes.includes(activekey()) && !localStorage.getItem('vedhvidhi-admin-token')) {
    return (
      <div id="ebazar-layout" className='theme-blue'>
        {toastContainer}
        <AuthIndex />
      </div>
    );
  }

  return (
    <AuthProvider>
      <PrivilegesConfigProvider>
        <div id="ebazar-layout" className='theme-blue'>
          {toastContainer}
          <Sidebar activekey={activekey()} history={props.history} />
          <AddModal />
          <MainIndex activekey={activekey()} />
        </div>
      </PrivilegesConfigProvider>
    </AuthProvider>
  );
}

export default App;